"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rsvpBodyFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
exports.rsvpBodyFactory = Factory.Sync.makeFactory({
    event_id: Factory.each(() => uuid_1.v4()),
    note: 'test',
    persona_id: '1',
    response: 'yes',
    team_id: Factory.each(() => uuid_1.v4()),
});
